import Hero from "@/components/home/Hero";
import HeroBuyCard from "@/components/home/HeroBuyCard";
import TrustStrip from "@/components/home/TrustStrip";
import TrustVerificationBand from "@/components/home/TrustVerificationBand";
import BestSellers from "@/components/home/BestSellers";
import PenAnnotation from "@/components/home/PenAnnotation";
import HowItWorks from "@/components/home/HowItWorks";
import Bundles from "@/components/home/Bundles";
import FeaturedBundleStrip from "@/components/home/FeaturedBundleStrip";
import FormatChoice from "@/components/home/FormatChoice";
import TrustpilotReviews from "@/components/home/TrustpilotReviews";
import Faq from "@/components/home/Faq";

// Round 2 homepage layout (2026-02-14): alternating background rhythm
// Cream → White → Dark navy → Cream → White → Dark navy → Cream, with FAQ
// pulled to just above the footer. Sections are the components below,
// backgrounds live inside each component so the rhythm is authoritative.
//   1. Hero + HeroBuyCard        (Cream, default)
//   2. TrustStrip                 (White)
//   3. TrustVerificationBand      (Dark navy, live lot data)
//   4. BestSellers                (Cream)
//   5. PenAnnotation              (White, DIAL·CLICK·DONE)
//   6. HowItWorks                 (Dark navy, 3-step)
//   7. Bundles                    (Cream)
//   8. FormatChoice (Three formats · White)
//   9. TrustpilotReviews          (Cream, placeholder)
//   10. Faq                       (White, just above footer)
export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <HeroBuyCard />
      <TrustStrip />
      <TrustVerificationBand />
      <BestSellers />
      <FeaturedBundleStrip />
      <PenAnnotation />
      <HowItWorks />
      <Bundles />
      <FormatChoice />
      <TrustpilotReviews />
      <Faq />
    </div>
  );
}
